import axios from 'axios'
import {UserModel} from '../models/UserModel'

console.log('IT00005', process.env)
const HRMS_API_URL = process.env.REACT_APP_HRMS_PROJECT_API_URL
const API_URL = process.env.REACT_APP_API_URL

export const LOGIN_Main_URL = `${HRMS_API_URL}/Employee/LogInApi`

export const LOGIN_URL = `${API_URL}/LogIn/EmployeeLogIn`
export const LOGINNew_URL = `${API_URL}/LogIn/EmployeeLogInNew`
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/auth/sa/user/login1`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
// export function login(userName: string, password: string) {
//   return axios.post(LOGIN_URL, {
//     userName,
//     password,
//   })
// }
export function login_New(userName: string, password: string) {
  console.log(HRMS_API_URL)
  console.log(LOGIN_Main_URL)
  return axios.post(LOGIN_Main_URL, {
    userName,
    password,
  })
}

export function login(userName: string, password: string) {
  return axios.post(LOGIN_URL, {
    userName,
    password,
  })
}
export function loginnew(LogIN: string) {
  return axios.post(LOGINNew_URL, {LogIN})
}
// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    firstName: firstname,
    lastName: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
